import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcChartColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.0992 4.5H17.9999V3.5H21.9999V7.5H20.9999V5.05517L15.997 9.14844L12.9874 6.64045L6.80478 11.3963L6.19507 10.6037L13.0124 5.35958L16.0028 7.8516L20.0992 4.5Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.5,
			y: 12.5,
			width: 5,
			height: 11.5,
			rx: 1,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 15.5,
			width: 5,
			height: 8.5,
			rx: 1,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.5,
			y: 9.5,
			width: 5,
			height: 14.5,
			rx: 1,
			fill: "#8C81F7"
		})
	]
});
export default SvgIcChartColor;
